import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CampaignsList from './pages/campaigns/CampaignsList';
import CampaignEdit from './pages/campaigns/CampaignEdit';
import GameTemplates from './pages/game-templates/GameTemplates';
import GameManager from './pages/games/GameManager';
import Gifts from './pages/gifts/Gifts';
import Players from './pages/players/Players';
import Reports from './pages/reports/Reports';
import AuditLogs from './pages/audit-logs/AuditLogs';
import Billing from './pages/billing/Billing';
import PaymentSuccess from './pages/billing/PaymentSuccess';
import PaymentCancel from './pages/billing/PaymentCancel';
import GamePreview from './pages/games/GamePreview';
import Settings from './pages/settings/Settings';
import SystemSettings from './pages/system/SystemSettings';
import Moderation from './pages/system/Moderation';
import GoogleCallback from './pages/auth/GoogleCallback';
import Users from './pages/users/Users';
import { useRouteError } from 'react-router-dom';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return <>{children}</>;
};

const ErrorPage = () => {
    const error = (window as any).__reactRouterError;
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
                <h1 className="text-6xl font-bold text-gray-300">Oops!</h1>
                <p className="text-gray-500 mt-2 mb-6">Có lỗi xảy ra. Vui lòng thử lại.</p>
                <a href="/dashboard" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                    Về Dashboard
                </a>
            </div>
        </div>
    );
};

const router = createBrowserRouter([
    {
        path: '/',
        element: <Outlet />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <ProtectedRoute><Navigate to="/dashboard" replace /></ProtectedRoute>,
            },
            {
                path: 'login',
                element: <Login />,
            },
            {
                path: 'auth/callback',
                element: <GoogleCallback />,
            },
            {
                path: 'dashboard',
                element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
            },
            {
                path: 'campaigns',
                element: <ProtectedRoute><CampaignsList /></ProtectedRoute>,
            },
            {
                path: 'campaigns/new',
                element: <ProtectedRoute><CampaignEdit /></ProtectedRoute>,
            },
            {
                path: 'campaigns/:id',
                element: <ProtectedRoute><CampaignEdit /></ProtectedRoute>,
            },
            {
                path: 'games',
                element: <ProtectedRoute><GameManager /></ProtectedRoute>,
            },
            {
                path: 'game-templates',
                element: <ProtectedRoute><GameTemplates /></ProtectedRoute>,
            },
            {
                path: 'gifts',
                element: <ProtectedRoute><Gifts /></ProtectedRoute>,
            },
            {
                path: 'players',
                element: <ProtectedRoute><Players /></ProtectedRoute>,
            },
            {
                path: 'reports',
                element: <ProtectedRoute><Reports /></ProtectedRoute>,
            },
            {
                path: 'billing',
                element: <ProtectedRoute><Billing /></ProtectedRoute>,
            },
            {
                path: 'billing/success',
                element: <ProtectedRoute><PaymentSuccess /></ProtectedRoute>,
            },
            {
                path: 'billing/cancel',
                element: <ProtectedRoute><PaymentCancel /></ProtectedRoute>,
            },
            {
                path: 'audit-logs',
                element: <ProtectedRoute><AuditLogs /></ProtectedRoute>,
            },
            {
                path: 'settings',
                element: <ProtectedRoute><Settings /></ProtectedRoute>,
            },
            {
                path: 'users',
                element: <ProtectedRoute><Users /></ProtectedRoute>,
            },
            {
                path: 'system',
                element: <ProtectedRoute><SystemSettings /></ProtectedRoute>,
            },
            {
                path: 'system/moderation',
                element: <ProtectedRoute><Moderation /></ProtectedRoute>,
            },
            {
                // Preview routes — không cần auth, trước catch-all
                path: 'preview/instance/:id',
                element: <GamePreview />,
            },
            {
                path: 'preview/template/:id',
                element: <GamePreview />,
            },
            {
                // Catch-all: trang không tồn tại
                path: '*',
                element: (
                    <div className="min-h-screen flex items-center justify-center bg-gray-50">
                        <div className="text-center">
                            <h1 className="text-6xl font-bold text-gray-300">404</h1>
                            <p className="text-gray-500 mt-2 mb-6">Trang không tồn tại</p>
                            <a href="/dashboard" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                                Về Dashboard
                            </a>
                        </div>
                    </div>
                ),
            },
        ],
    },
]);

export default router;
